import React from 'react';
import ProfitSalesAnnouncement from 'src/molecules/Standard/Homepage/2024_Q1_people_magic/ProfitSalesAnnouncement/ProfitSalesAnnouncement';
import { usePeopleMagicDesignController } from 'src/hooks/usePeopleMagicDesignController';
import { OpportunityCalculatorStaticContainer } from './OpportunityCalculatorStatic.styles';
import OpportunityCalculatorContent from 'src/molecules/Standard/Homepage/2024_Q1_people_magic/OpportunityCalculatorContent/OpportunityCalculatorContent';

const OpportunityCalculatorStatic = (): JSX.Element => {
  const { homepage } = usePeopleMagicDesignController();
  const hasPeopleMagicProfitAnnouncementAtTop = homepage?.hasPeopleMagicAdvertisementMovedToTop;

  return (
    <OpportunityCalculatorStaticContainer id='ROI-calculator'>
      {!hasPeopleMagicProfitAnnouncementAtTop && <ProfitSalesAnnouncement />}
      <OpportunityCalculatorContent />
    </OpportunityCalculatorStaticContainer>
  );
};

export default OpportunityCalculatorStatic;
